// src/components/mentions/TexteAvecMentions.tsx — SCE Issues
// Un texte affiché (commentaire, description) où les « @Prénom Nom » se
// détachent (02/11) : en gras, comme on les lit dans le mail. Le texte reste
// celui de SharePoint, rien n'est réécrit (utils/mentions, morceauxMentions).

import type { JSX } from 'react'
import { morceauxMentions } from '@/utils/mentions'

export function TexteAvecMentions({ texte }: { texte: string }): JSX.Element {
  if (!texte.includes('@')) return <>{texte}</>
  return (
    <>
      {morceauxMentions(texte).map((m, i) =>
        m.mention ? (
          <span key={i} className="mention">
            {m.texte}
          </span>
        ) : (
          m.texte
        ),
      )}
    </>
  )
}
